import {
    ApiBaseService,
    type PaginatedFetch,
    type PaginatedFetchOptions,
    } from "./ApiBaseService";
import type { FieldDefinition } from "~/models/Automation";
import type { ApiResponse } from "~/types/ApiResponse";

export type BlackListType = 'email' | 'phone'
export type BlackListCondition = 'starts_with' | 'ends_with' | 'equals' | 'contains';

export interface BlackList {
    id: number
    type: BlackListType
    condition: BlackListCondition
    value: string
    created_at: string
    updated_at: string
}

export interface Unsubscribe {
    id: number
    from_type: string
    from_id: number
    address_type: string
    address_value: string
    category: string
    unsubscribe_reason: string
    unsubscribed_at: string
}

export type CreateOrUpdateBlackList = Omit<BlackList, 'id' | 'created_at' | 'updated_at'>;

export default class BlackListService extends ApiBaseService {
    public list(): Promise<ApiResponse<BlackList[]>> {
        return this.request(
            this.route("api.black-lists.index", "/safety-limits/black-lists"),
        );
    }

    public store(data: CreateOrUpdateBlackList): Promise<ApiResponse<BlackList>> {
        return this.request(this.route("api.black-lists.store", "/safety-limits/black-lists"), {
            method: "POST",
            body: data,
        });
    }

    public find(id: string): Promise<ApiResponse<BlackList>> {
        return this.request(
            this.route("api.black-lists.show", "/safety-limits/black-lists/{id}", {
                id,
            }),
        );
    }

    public listFieldMap(
        id: string,
        data: CreateOrUpdateBlackList,
    ): Promise<ApiResponse<FieldDefinition[]>> {
        return this.request(
            this.route("api.black-lists.field_map", "/safety-limits/black-lists/{id}/fields", {
                id,
            }),
            {
                method: "POST",
                body: data,
            },
        );
    }

    public update(
        id: string,
        data: CreateOrUpdateBlackList,
    ): Promise<ApiResponse<BlackList>> {
        return this.request(
            this.route("api.black-lists.store", "/safety-limits/black-lists/{id}", {
                id,
            }),
            {
                method: "PATCH",
                body: data,
            },
        );
    }

    public delete(id: string): Promise<null> {
        return this.request(
            this.route("api.black-lists.destroy", "/safety-limits/black-lists/{id}", {
                id,
            }),
            {
                method: "DELETE",
            },
        );
    }
}
